import React from 'react';
import { CollapseList, ICollapseListProps } from '@lion-design/core';
import styles from './styles.module.scss';

const Table: React.FC<ICollapseListProps> = ({ titles, dataSource }) => (
    <CollapseList titles={titles} dataSource={dataSource} className={styles.table} />
);

export default Table;
